import React from 'react';
import { translate } from '../translations';
import tempImg from '../images/contact_navImg.png';
import logo from '../images/logo.jpg';
import { getTheme } from '../Theme';

const About = () => {
  return (
    <section id='about'>
      <img className={getTheme('template-img')} src={tempImg} alt='test' />
      <div className='container'>
        <div className='about-row'>
          <div className={getTheme('col-md-6')} style={{ padding: 0 , alignSelf: 'center' }}>
            <div className='col-inner-center'>
              <div>
                <img
                  className={getTheme('about-logo')}
                  src={logo}
                  alt={'logo'}
                />
              </div>
            </div>
          </div>

          <div className={getTheme('col-md-6')}>
            <div className="col-inner-center about-text">
              <p>
                {translate('Spółka')} <b>Filipek - Motors Sp. z o. o.</b>{' '}
                {translate(
                  'została zawiązana w dniu 13.12.2018 r. jako spółka typu spin-off.'
                )}
              </p>
              <p>
                {translate('Większościowym udziałowcem (90%) jest')}{' '}
                <b>dr inż. Przemysław Filipek, </b>
                {translate(
                  'adiunkt w Katedrze Podstaw Konstrukcji Maszyn i Mechatroniki, Wydziału Mechanicznego Politechniki Lubelskiej.'
                )}
              </p>
              <p>
                {translate('Drugim udziałowcem (10%) jest')} "
                <b>Pollub-Invest</b>" -{' '}
                {translate(
                  'spółka celowa Politechniki Lubelskiej reprezentowana przez'
                )}{' '}
                <b>{translate('dr inż. Grzegorza Kłosowskiego')}</b>,{' '}
                {translate(
                  'adiunkta w Katedrze Organizacji Przedsiębiorstwa, Wydziału Zarządzania'
                )}
                .
              </p>

              <p>
                {translate('Prezesem Zarządu spółki jest')}{' '}
                <b>dr. inż. Korneliusz Dubicki</b> -{' '}
                {translate(
                  'posiadający duże doświadczenie w zarządzaniu firmami'
                )}
                .
              </p>

              <p>
                {translate(
                  'Siedziba spółki Filipek - Motors Sp. z o. o. znajduje się przy ul.Nadbystrzyckiej 38H, 20-618 Lublin.'
                )}
              </p>

              <div className="about-company-info">
                <div>
                  <h3 className="about-h3"> KRS: &nbsp;</h3>
                  <p> 0000767346 </p>
                </div>

                <div>
                  <h3 className="about-h3"> Regon: &nbsp;</h3>
                  <p>382358174</p>
                </div>

                <div>
                  <h3 className="about-h3"> NIP: &nbsp;</h3>
                  <p>9462685876</p>
                </div>

                <div>
                  <h3 className="about-h3">
                    {translate('Kapitał zakładowy:')} &nbsp;
                  </h3>
                  <p>30 000 zł</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
